import { getProgrammeIcon } from './ProgrammeIcons';

export default function ProgrammeItem(item) {

    const time = item.end
        ? `${item.start}–${item.end}`
        : item.start;

    const speaker = item.speaker
        ? `${item.speaker.firstName} ${item.speaker.lastName}`
        : '';

    const affiliation = item.speaker
        ? item.speaker.affiliation
        : '';

    const room = item.room
        ? item.room.name
        : '';

    return `

        <article class="programme-item programme-item--${item.type}">

            <div class="programme-item__time">

                ${time}

            </div>

            <div class="programme-item__timeline">

                <div class="programme-item__dot">

                    ${getProgrammeIcon(item.type)}

                </div>

            </div>

            <div class="programme-item__card">

                <div class="programme-item__header">

                    <h3>${item.title}</h3>

                    ${
                        room
                            ? `<span class="programme-item__room">${room}</span>`
                            : ''
                    }

                </div>

                ${
                    speaker
                        ? `

                            <div class="programme-item__speaker">

                                ${speaker}

                            </div>

                            <div class="programme-item__affiliation">

                                ${affiliation}

                            </div>

                        `
                        : ''
                }

            </div>

        </article>

    `;

}
